<h1>Zurücksetzen bestätigen</h1>

<p>
  Bitte klicken Sie auf "Bestätigen", um das Passwort oder die Aktivierungs-E-Mail<br>
  für den Zugang für <strong>{{email}}</strong> zurückzusetzen.<br>
  Sie werden in beiden Fällen eine E-Mail mit weiteren Informationen erhalten.
</p>

<div class="button-bar">
  <button mat-raised-button [disabled]="loading" class="login-button" (click)="submit()">
    <mat-spinner *ngIf="loading"></mat-spinner>
    <mat-icon [class.hidden]="loading">check</mat-icon>
    Bestätigen
  </button>
</div>

<div class="errors">
  <div *ngIf="errFailure">
    <mat-icon>close</mat-icon>
    Es ist ein Fehler aufgetreten.
  </div>
  <div *ngIf="errInvalidCode">
    <mat-icon>close</mat-icon>
    Der Link ist nicht gültig oder wurde bereits verwendet. Bitte verwenden Sie die Funktion "Zugang zurücksetzen" erneut.
  </div>
</div>
